import { MessageTypes } from './constants';
import type { ActivityState, LearnerToParentMessage } from '@praktio/common-ui';

export const forwardActivity = (state: ActivityState) => {
  if (window.parent && document.referrer) {
    window.parent.postMessage(
      { type: MessageTypes.Activity, data: { state } } satisfies LearnerToParentMessage,
      document.referrer,
    );
  }
};
